<script setup>
import { useTranslations } from '@/composables/translations'

const { translate } = useTranslations()

const props = defineProps({
  attachments: {
    default: () => [],
    type: Array,
    required: true
  }
})

const ariaLabelDownloadAttachment = (attachment) => {
  return `${translate('download')} ${attachment.title}`
}

</script>

<template>
  <div class="row attachments justify-content-center">
    <div class="col-lg-8">
      <div
        v-for="(attachment, index) in props.attachments"
        :key="index"
        class="row attachment justify-content-center"
      >
        <div
          v-if="attachment.attachment"
          class="col-12 order-2 col-sm-9 text-sm-start text-center attachment-text"
        >
          <h2 class="mm-color-text">
            {{ attachment.title }}
          </h2>
          <div
            v-if="attachment.content"
            class="mm-color-text"
            v-html="attachment.content"
          />
          <div v-if="!attachment.content">
            <p />
          </div>
          <a
            :href="attachment.link"
            class="btn btn-2"
            target="_blank"
            :aria-label="ariaLabelDownloadAttachment(attachment)"
          >
            {{ attachment.download_button || translate('download') }}
          </a>
        </div>
        <div
          v-if="!attachment.attachment"
          class="col-12"
        >
          <div
            class="row content mm-html attachment-content"
            v-html="attachment.content"
          />
        </div>
        <div
          v-if="attachment.attachment"
          class="col-6 order-1 col-sm-3 attachment-type-container"
        >
          <div class="attachment-type d-flex justify-content-center align-items-center">
            <p class="h1 extension">
              {{ attachment.extension }}
            </p>
          </div>
        </div>
        <div
          v-if="index !== (props.attachments.length-1)"
          class="col-12 order-3"
        >
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" type="text/sass" scoped>
.attachments
  .attachment-content
    padding-top: 27px

  .attachment
    hr
      margin: 30px 0

    .attachment-type-container
      left: auto

    @include media-breakpoint-down(lg)
      .attachment-type
        margin-bottom: 30px

    @include media-breakpoint-down(sm)
      .attachment-type-container
        left: 25%

    .attachment-type
      aspect-ratio: 1

      .content
        position: absolute
        height: 100% /* = 100% - 2*10% padding */
        width: 100% /* = 100% - 2*5% padding */
        padding: 10% 5%
        text-align: center

    .attachment-text
      h2
        display: block
        font-weight: 600
        padding-bottom: 0
        margin-bottom: 0px
        margin-top: -10px
        text-align: left
      @include media-breakpoint-only(xs)
        h2
          text-align: center

      p
        a
          font-weight: 600
</style>
